import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {create} from "../../../app/setters/create.js";
import {useState} from "react";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";

export const useDodajZdarzenieProcesuProjektu = (setErrors, close) => {

    const queryClient = useQueryClient()


    return useMutation({
        mutationFn: (data) => {
            return create(`/oper/${MAIN_REJESTR_API_SHORT}/proces`, data)
        },
        onError: () => {
            toast.error('Błąd podczas operacji')
        },
        onSettled: async (data, error, variables) => {

            await queryClient.invalidateQueries({
                queryKey: [`lista_procesow_element__${variables.rejestr_id}`],
            })
        },
        onSuccess: async ({message, status, errors}) => {
            if (setErrors) await setErrors(errors)
            status === 'success' ? await toast.success(message) : await toast.error(message)
            if (status === 'success' && close) close()
        },
    })
}